import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAuthed } from '../redux/slice/login/loginSlice';
export const useAuth = (): any => {
    const loginData = useSelector((state: any) => state.login);
    const dispatch = useDispatch();
    useEffect(() => {
        const token = sessionStorage.getItem('access_token') || '';
        if (token) {
            dispatch(
                setAuthed({
                    authed: true,
                    token,
                })
            );
        }
    }, []);
    const login = (data: any): Promise<boolean> => {
        return new Promise((res) => {
            dispatch(
                setAuthed({
                    authed: true,
                    token: data,
                })
            );
            res(true);
        });
    };
    const logout = (): Promise<boolean> => {
        return new Promise((res) => {
            dispatch(
                setAuthed({
                    authed: false,
                    token: null,
                })
            );
            sessionStorage.removeItem('access_token');
            res(true);
        });
    };
    return {
        authed: loginData.authed,
        value: loginData.value,
        login,
        logout,
    };
};
